// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3W-5b","content":"styles_content__Z_pWT"};